import axios from "axios";
import useToast from "./ToastHook";

const apiUrl = process.env.REACT_APP_AUTH_API_URL || 'http://localhost:9000'

export default function useApi() {

    const { showAxiosError } = useToast();

    const api = axios.create({
		baseURL: apiUrl
	});

    api.interceptors.response.use(r => r, e => {
		showAxiosError(e);
		return Promise.reject(e);
	});

    return api;

}